import * as React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';
import { Textfit } from 'react-textfit';
import { ICategoryType } from '../../../all-types';

interface CategoryCardProps {
    category: ICategoryType;
    selectedCategory: string;
    onClick: () => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category, onClick, selectedCategory }) => {
    const theme = useTheme();
    const isSelected = selectedCategory === category.categoryName;

    const DEFAULT_IMG = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!--%20License%3A%20GPL.%20Made%20by%20Wordpress%3A%20https%3A%2F%2Fgithub.com%2Fwordpress%2Fdashicons%20--%3E%3Csvg%20width%3D%22800px%22%20height%3D%22800px%22%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%220%22%20fill%3D%22none%22%20width%3D%2220%22%20height%3D%2220%22%2F%3E%3Cg%3E%3Cpath%20d%3D%22M7%204.5c-.3%200-.5.3-.5.5v2.5h-1V5c0-.3-.2-.5-.5-.5s-.5.3-.5.5v2.5h-1V5c0-.3-.2-.5-.5-.5s-.5.3-.5.5v3.3c0%20.9.7%201.6%201.5%201.7v7c0%20.6.4%201%201%201s1-.4%201-1v-7c.8-.1%201.5-.8%201.5-1.7V5c0-.2-.2-.5-.5-.5zM9%205v6h1v6c0%20.6.4%201%201%201s1-.4%201-1V2c-1.7%200-3%201.3-3%203zm7-1c-1.4%200-2.5%201.5-2.5%203.3-.1%201.2.5%202.3%201.5%203V17c0%20.6.4%201%201%201s1-.4%201-1v-6.7c1-.7%201.6-1.8%201.5-3C18.5%205.5%2017.4%204%2016%204z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
    return (
        <Box
            onClick={onClick}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                padding: 2,
                margin: 0.5,
                width: "95%",
                borderRadius: 2,
                overflow: "hidden",
                border: isSelected ? `2px solid ${theme.palette.primary.main}` : `2px solid ${theme.palette.divider}`,
                cursor: 'pointer',
                height: "80px",
                backgroundColor: isSelected ? theme.palette.primary.light : theme.palette.background.paper,
                color: isSelected ? theme.palette.primary.contrastText : theme.palette.text.primary,
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                textOverflow: "ellipsis",
                '&:hover': {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    fontWeight: "bold",
                },
            }}

        >
            <img
                src={category.categoryIcon || DEFAULT_IMG}
                alt={category.categoryName}
                style={{ width: '40px', height: '40px', marginRight: theme.spacing(1) }}
            />

            <Typography variant="button" sx={{
                fontWeight: isSelected ? "bold" : "normal",
                textOverflow: "ellipsis",
                textTransform: "capitalize",
                fontSize: "0.8rem",
                //overflow: "hidden",
                whiteSpace: "nowrap",
                //width: "100%",
            }}>
                <Textfit mode="multi" >
                    {category?.categoryName}
                </Textfit>
            </Typography>
            <Link underline="none" onClick={onClick}>
                {' '}
            </Link>
        </Box >
    );
};

export { CategoryCard };